import ModalWrapper from './ModalWrapper';
import { useDispatch, useSelector } from '../redux/hooks';
import { closeShoppingCart } from '../redux/slices/modalSlice';
import ShoppingCart from './ShoppingCart';

const ShoppingCartModal = () => {
  const shoppingCartOpen = useSelector((state) => state.modal.shoppingCartOpen);
  const dispatch = useDispatch();

  if (!shoppingCartOpen) return null;

  return (
    <ModalWrapper onClick={() => dispatch(closeShoppingCart())}>
      <div onClick={(e) => e.stopPropagation()}>
        <ShoppingCart />
      </div>
    </ModalWrapper>
  );
};

export default ShoppingCartModal;